import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export function ProtectedRoute({ children }) {
  const { user, booting } = useAuth();
  if (booting) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[color:var(--nr-bg)]">
        <div className="text-[color:var(--nr-ink-soft)] text-sm tracking-[0.2em] uppercase">
          Loading…
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}
